module.exports = __webpack_public_path__ + "img/pic1.059578bb.png";